import { useParams } from 'react-router-dom';

import { Order as OrderComponent } from '../../components/Order';
import { Loading } from '../../../components/Loading';
import { Error } from '../../../components/Error';
import { useOrder } from '../../hooks/useOrder';

export const Order: React.FC = () => {
	const params = useParams();
	const { order, error, subscriptionError } = useOrder(
		params?.id?.split(':').pop()
	);

	if (error) {
		return (
			<Error
				error={
					error.message ??
					`Woops! Something went wrong when we tried to find this order. Order id: ${params.id}`
				}
			/>
		);
	}

	if (!order) {
		return <Loading />;
	}

	return (
		<div className="order mb-3 order-order">
			{subscriptionError && <Error error={subscriptionError.message} />}

			<OrderComponent order={order} />
		</div>
	);
};
